<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton btnTitle="Add New" :showBtn="false" :showAddNew="true" title="FD6 List"
                   @onClickAddNewButton="onClickAddNewButton"/>
      <div class="row match-height mt-1">
        <div class="col-12">
          <DateQuerySetter @onClickGo="getProjects"/>
        </div>
      </div>
    </div>

    <ListTable :project-list="projectList"/>
    <div class="mb-2"></div>
    <div class="px-2 position-absolute bottom-0">
      <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import TitleButton from '@/components/atom/TitleButton'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import ListTable from '@/components/molecule/procurement/fd6/ListingTable'
import Pagination from '@/components/atom/Pagination'
import {useRoute, useRouter} from "vue-router";
import handleFD6s from "@/services/modules/procurement/fd6";

const router = useRouter()
const route = useRoute()
const offset = ref(20);
let page = ref(1);
let loading = ref(false);
let projectList = ref([]);
let {
  fetchFD6List,
} = handleFD6s();
let companyId = computed(() => route.params.companyId);

function onClickAddNewButton() {
  router.push({name: 'fd6-add', params: route.params, query: route.query})
}

async function getProjects() {
  loading.value = true;
  try {
    const res = await fetchFD6List(getQuery());
    if (res.status) {
      projectList.value = res.data;
    }
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  } finally {
    loading.value = false;
  }
}

function getQuery() {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  if (page.value) query += '&page=' + page.value
  return query
}

function onPageChange(page) {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  router.push({path: route.path, query: routeQuery})
  setTimeout(() => {
    getProjects();
  }, 100)
}

onMounted(async () => {
  await getProjects();
})
</script>
